export default {
      id: "play-usage",
      viewBox: "0 0 19 27",
      url: __webpack_public_path__ + "img/icons.e748fd75.svg#play",
      toString: function () {
        return this.url;
      }
    }